import type { DeleteLibraryBookIdResponseDto } from './dto';
import type { DeleteLibraryBookIdParams } from './repository.types';

// DeleteLibraryBookId
export const mapDeleteLibraryBookIdModelToRequestDTO = (
  model: DeleteLibraryBookIdParams,
): DeleteLibraryBookIdParams => {
  return model;
};

export const mapDeleteLibraryBookIdResponseDTOToModel = (
  response: DeleteLibraryBookIdResponseDto,
) => {
  return response;
};
import type { PatchLibraryBookIdResponseDto } from './dto';
import type { PatchLibraryBookIdParams } from './repository.types';

// PatchLibraryBookId
export const mapPatchLibraryBookIdModelToRequestDTO = (
  model: PatchLibraryBookIdParams,
): PatchLibraryBookIdParams => {
  return model;
};

export const mapPatchLibraryBookIdResponseDTOToModel = (
  response: PatchLibraryBookIdResponseDto,
) => {
  return response;
};
